import { DpDatePickerModule } from 'ng2-date-picker';

import { CommonModule } from '@angular/common';
import { Input, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import {
    AdditionalDocumentRequestComponent
} from './additional-document-request/additional-document-request.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { BadgeComponent } from './components/badge/badge.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { DateInputsComponent } from './components/date-inputs/date-inputs.component';
import { DisplayErrorsComponent } from './components/display-errors/display-errors.component';
import { DropDownComponent } from './components/drop-down/drop-down.component';
import { InputWrapperComponent } from './components/input-wrapper/input-wrapper.component';
import { ModalComponent } from './components/modal/modal.component';
import { NavPage } from './components/navigation/nav-page';
import { NavPageSubtitle } from './components/navigation/nav-page-subtitle';
import { NavPageTitle } from './components/navigation/nav-page-title';
import { Navigation } from './components/navigation/navigation';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { RadioGroupComponent } from './components/radio/radio-group.component';
import { RadioComponent } from './components/radio/radio.component';
import {
    RequiredInputWrapperComponent
} from './components/required-input-wrapper/required-input-wrapper.component';
import { OptionComponent } from './components/select/option.component';
import { SelectComponent } from './components/select/select.component';
import { FlagComponent } from './components/svg/flag.component';
import { IconComponent } from './components/svg/icon.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { UnexpectedErrorComponent } from './components/unexpected-error/unexpected-error.component';
import { UploadComponent } from './components/upload/upload.component';
import { ButtonDirective } from './directives/button.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { DragDirective } from './directives/dragDrop.directive';
import { FormatNumberDirective } from './directives/formatNumber.directive';
import { IconButtonDirective } from './directives/icon-button.directive';
import { InputBaseClass } from './directives/input-base-class.directive';
import { InputDirective } from './directives/input.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { UppercaseDirective } from './directives/uppercase.directive';
import { IdCardExpiredComponent } from './id-card-expired/id-card-expired.component';
import {
    IdExpiredForceLogoutComponent
} from './id-expired-force-logout/id-expired-force-logout.component';
import { NotificationComponent } from './notification/notification.component';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { FillEmptyPipe } from './pipes/fill-empty.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import {
    StrenghPasswordCheckerComponent
} from './strengh-password-checker/strengh-password-checker.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { UploadKycComponent } from './upload-kyc/upload-kyc.component';

@NgModule({
  declarations: [
    AvatarComponent,
    BadgeComponent,
    CheckboxComponent,
    FlagComponent,
    IconComponent,
    ModalComponent,
    Navigation,
    NavPage,
    NavPageSubtitle,
    NavPageTitle,
    OptionComponent,
    OtpInputComponent,
    RadioComponent,
    RadioGroupComponent,
    SelectComponent,
    ToggleComponent,
    ButtonDirective,
    IconButtonDirective,
    InputDirective,
    NumberOnlyDirective,
    SafeHtmlPipe,
    NotificationComponent,
    UploadComponent,
    DisplayErrorsComponent,
    StrenghPasswordCheckerComponent,
    InputWrapperComponent,
    InputBaseClass,
    RequiredInputWrapperComponent,
    DateInputsComponent,
    FormatNumberDirective,
    StripHtmlPipe,
    AdditionalDocumentRequestComponent,
    IdCardExpiredComponent,
    UploadKycComponent,
    FillEmptyPipe,
    ClickOutsideDirective,
    DragDirective,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    CustomSelectComponent,
    DropDownComponent,
    IdExpiredForceLogoutComponent,
    UnexpectedErrorComponent,
    CapitalizePipe,
    UppercaseDirective
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, DpDatePickerModule],
  exports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AvatarComponent,
    BadgeComponent,
    CheckboxComponent,
    FlagComponent,
    IconComponent,
    ModalComponent,
    Navigation,
    NavPage,
    NavPageSubtitle,
    NavPageTitle,
    OptionComponent,
    OtpInputComponent,
    RadioComponent,
    RadioGroupComponent,
    SelectComponent,
    ToggleComponent,
    ButtonDirective,
    IconButtonDirective,
    InputDirective,
    NotificationComponent,
    NumberOnlyDirective,
    SafeHtmlPipe,
    UploadComponent,
    DisplayErrorsComponent,
    StrenghPasswordCheckerComponent,
    DpDatePickerModule,
    InputWrapperComponent,
    InputBaseClass,
    RequiredInputWrapperComponent,
    DateInputsComponent,
    FormatNumberDirective,
    StripHtmlPipe,
    AdditionalDocumentRequestComponent,
    IdCardExpiredComponent,
    UploadKycComponent,
    FillEmptyPipe,
    ClickOutsideDirective,
    DragDirective,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    CustomSelectComponent,
    DropDownComponent,
    IdExpiredForceLogoutComponent,
    UnexpectedErrorComponent,
    CapitalizePipe,
    UppercaseDirective
  ]
})
export class SharedModule {}
